import "./homepage.scss";
import "./storefinder-form.js";
import heroSlider from "../components/hero-banner/_hero-banner.js";

document.addEventListener("DOMContentLoaded", function() {
    try{ heroSlider.init(); } catch(e) { document.body.append(e); }
});
